import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  'app.request.error.title.400': '404',
  'app.request.error.message.400': 'Page not found',
  'app.request.error.403': 'Forbidden',
  'app.request.error.404': 'Not Found',
  'app.request.error.500': 'Internal Server Error',
  'app.request.error.502': 'Bad Gateway',
  'app.request.error.503': 'Service Unavailable',
  'app.request.error.504': 'Gateway Timeout',
  'app.request.error-request': 'Request error!',
  'app.category.review': 'Review',
  'app.legend': 'Légende',
  'app.legend.independent_care': 'Soins Indépendants',
  'app.legend.acute_care': 'Soins Actifs',
  'app.legend.basic_care': 'Soins de Dase',
  'app.legend.requires_exp': 'Nécessite une Explication',
  'app.legend.caution_care': 'Soins de Prudence',
  'app.legend.condition_info': 'Informations sur l’état',
  'app.legend.notable_care': 'Soins Notables',
  'app.legend.required_info': 'Informations Requises',
  'app.estimate_cost': 'Coût estimatif',
  'app.per_hour_commonapp': 'par heure',
  'app.estimate_cost_commonapp': 'Taux horaire estimé',
  'app.estimate_cost.quote-id': 'ID du devis',
  'app.estimate_cost.secondary': 'Citation secondaire',
  'app.estimate_cost.secondary_minamalCare': 'Autre personne dans l’hébergement – un minimum de soins requis',
  'app.estimate_cost.secondary_minamalCare_commonapp': 'NOTE: PRICING FOR CARE RECIPIENT 1',
  'app.estimate_cost.contagion_cost': 'Coût estimé de la contagion',
  'app.estimate_cost.contagion_note': 'Note: Le taux régulier sera utilisé une fois le statut de contagion terminé.',
  'app.estimate_cost.note-1': 'Merci d’avoir soumis votre soumission.',
  'app.estimate_cost.note-2':
    'Veuillez vérifier votre e-mail pour connaître le coût estimé de votre devis et votre code de devis unique.',
  'app.estimate_cost.note-3':
    'Un représentant de l’agence communiquera avec vous pour examiner votre soumission.',
  'app.estimate_cost.note-4': 'Pour quitter, veuillez fermer votre navigateur.',
  'app.estimate_cost.note-5': `Si vous ne voyez pas l'e-mail dans votre boîte de réception en quelques minutes, veuillez vérifier votre dossier “courrier indésirable” ou votre dossier “spam”.
Veuillez marquer le message électronique comme non indésirable ou spam, de sorte que les e-mails envoyés à partir de cette adresse seront automatiquement déplacés vers son dossier d'origine.`,
  'app.estimate_cost.note-6': `Si vous ne recevez toujours pas d'e-mail, écrivez à info@homecarequote.com ou appelez le (678)-809-9200 pour expliquer le problème. 
Nous répondrons à votre demande dans les plus brefs délais.`,
  'app.estimate_cost.note-commonapp_6': `Si vous ne recevez toujours pas d'e-mail, écrivez à Info@MyHomeCareQuote.com ou appelez expliquant le problème. 
Nous répondrons à votre demande dans les plus brefs délais.`,
  'app.estimate_cost.note-commonapp': "Si vous souhaitez qu'une copie PDF de ce devis vous soit envoyée par e-mail, veuillez fournir une adresse e-mail.",
  'app.estimate_cost.note-commonapp1': "Personne ne vous contactera à moins que vous ne l'autorisiez.",
  'app.estimate_cost.sendMailButton': 'Envoyer',
  'app.lable.notFoundAddress': "L’adresse est introuvable.",
  'app.lable.isHiddenPrice':"Ne pas inclure les prix dans ce devis",
  'app.button.back': 'Précédent',
  'app.button.next': 'Prochain',
  'app.button.save_draft': 'Enregistrer le brouillon et finaliser le devis plus tard',
  'app.button.ask_for_call': 'Appeler à l’aide',
  'app.button.update.question': 'Sauvegarder/Mettre à jour',
  'app.modal.yes': 'Oui',
  'app.modal.no': 'Non',
  'app.suggestion.noCommunication.content': 'You indicated that {name} is not aware that care is being explored. Is there currently no communication with {name} about care?',
  'app.suggestion.correct': 'Correct',
  'app.suggestion.notCorrect': 'Not correct',
  'app.reassess.confirm.question': 'Are all of the answers shown above still accurate?',
  'app.reassess.confirm.yes': 'Yes, keep these answers and continue',
  'app.reassess.confirm.no': 'No, I need to make changes',
  'app.reassess.confirm.required': 'Please confirm whether the answers above are still accurate.',
  'app.reassess.previousAnswer': 'Previous answer',
  'app.contactMethod.needPhone': 'Please add a phone number or choose another contact method.',
  'app.contactMethod.needEmail': 'Please add an email address or choose another contact method.',
  'app.modal.sameAsRename.title': 'New contact added',
  'app.modal.sameAsRename.content': 'This contact is also used in other roles. Do you want to update them with new contact info?',
  'app.modal.sameAsRename.yes': 'Yes, update',
  'app.modal.sameAsRename.no': 'No, keep the previous person',
  'app.address.entered': 'You entered',
  'app.address.suggested': 'Suggested',
  'app.address.zipNotFound': "We couldn't find ZIP code {zip}. Please check it.",
  'app.address.streetNotFound': "We couldn't verify this street in ZIP code {zip}.",
  'app.address.streetNotFoundShort': 'Street not found',
  'app.address.notFound': 'Not found',
  'app.address.useSuggested': 'Use suggested',
  'app.address.keepEntered': 'Keep what I entered',
  'app.address.confirmCorrect': 'Yes, this is correct',
  'app.address.edit': 'Edit address',
  'app.modal.ask.title': `Demandez de l'aide à l'agence`,
  'app.modal.ask.call_name': 'Full name',
  'app.modal.ask.call_phone': 'Numéro de téléphone',
  'app.modal.ask.button.cancel': 'Envoyer',
  'app.modal.ask.button.submit': 'Annuler',
  'app.modal.ask.contact': 'Quel est le meilleur moment pour prendre contact ?',
  'app.modal.quote.title': 'Load your quote',
  'app.modal.quote.button.new': 'New Quote',
  'app.modal.quote.button.continue': 'Continue',
  'app.modal.quote.placeholder': 'Quote ID...',
  'app.modal.quote.required-continue':
    'Quote will be out of date after 3 months. You will be able to key in the old quote ID to populate the old quotes, edit and create the new quote.',
  'app.modal.pinStaff.title': 'Entrez le code PIN du personnel',
  'app.modal.pinStaff.label': 'Staff PIN',
  'app.modal.relQuestion.title': 'Confirmation',
  'app.modal.relQuestion.pleaseSelect': 'Veuillez sélectionner',
  'app.modal.relQuestionChoiceConfirmSelect': `Vous n'avez pas sélectionné ce service dans la section "{nameQuestion}". {p}Souhaitez-vous le sélectionner maintenant?`,
  'app.modal.relQuestionChoiceConfirmDeselect': `Vous avez sélectionné ce service dans la section "{nameQuestion}". {p}Souhaitez-vous le désactiver ?`,
  'app.modal.confirmHeightWeight.content': 'Veuillez confirmer que les informations que vous avez saisies sont exactes avant de poursuivre.',
  'app.modal.saveDraft.title': 'Enregistrer le brouillon et finaliser le devis plus tard',
  'app.modal.saveDraft_name': 'Full name',
  'app.modal.saveDraft_phone': 'Numéro de téléphone',
  'app.modal.saveDraft_email': 'Email',
  'app.modal.saveDraft.button.cancel': 'Envoyer',
  'app.modal.saveDraft.button.submit': 'Annuler',
  'app.modal.saveDraft.note': "Merci d'utiliser HomeCareQuote..",
  'app.modal.saveDraft.isCompleteQuoteLable': "Souhaitez-vous terminer cette citation vous-même plus tard?",
  'app.modal.saveDraft.isContactLable': "Souhaitez-vous qu'un représentant HomeCareQuote vous contacte pour vous aider à compléter votre devis?",
  'app.modal.saveDraft.isNoContact': 'Veuillez noter que cela mettra fin à votre session HomeCareQuote. Vous ne recevrez aucune autre information ou correspondance de HomeCareQuote. Si vous souhaitez commencer un nouveau devis, veuillez visiter notre site Web pour commencer votre processus de devis.',
  'app.modal.saveDraft.isYesCompleteQuote': 'Veuillez saisir votre e-mail afin qu\'une copie puisse vous être envoyée pour être complétée à votre convenance.',
  'app.modal.saveDraft.isYesContact': 'Veuillez saisir vos coordonnées et une heure à laquelle vous souhaitez être contacté',
  'app.modal.siblingQuote.note': 'Vous réévaluez la citation secondaire {secondQuote}. La citation principale est {primaryQuote}.',
  'app.label.additionalPersonCommonApp': 'Veuillez sélectionner le deuxième soin ménager.',
  'app.label.other': "Autre",
  'app.label.age': 'Âge',
  'app.label.animal': 'Chiens, chats, oiseaux, cochons, poisson',
  'app.label.time': 'TIME',
  'app.label.selectAll': 'Sélectionnez tout ce qui s\'applique',
  'app.label.contact_me_on_date': 'CONTACTEZ-MOI À LA DATE',
  'app.label.transfers.height': 'Hauteur du destinataire du soin',
  'app.label.transfers.weight': 'Poids du bénéficiaire de soins',
  'app.label.transfers.height.unit': '(pouces)',
  'app.label.transfers.weight.unit': '(lbs)',
  'app.label.transfers.select': 'Sélectionnez l\'un des éléments suivants:',
  'app.label.transfers.option1': 'L\'assistance partielle du bénéficiaire de soins(peut aider certains avec le transfert)',
  'app.label.transfers.option2': 'L\'assistance totale du bénéficiaire de soins(ne peut pas du tout aider avec le transfert)',
  'app.label.generalConcernsAll.label': "Fumeur",
  'app.label.generalConcernsAll.option1': 'Fume à l\'intérieur de la maison / voiture',
  'app.label.generalConcernsAll.option2': 'Fume à l\'extérieur de la maison / voiture',
  'app.label.other.bathing': 'Veuillez expliquer',
  'app.label.email': 'Email',
  'app.label.name': 'Nom',
  'app.label.phone': 'Tél',
  'app.label.contact': 'Temps de contact',
  'app.lable.checkterm': "J’accepte les ",
  'app.lable.term': "Termes et Conditions",
  'app.lable.returnHomeCareQuote': "Retour à ",
  'app.lable.checkboxContactEmail': "Je souhaite que la communication par e-mail soit envoyée à cette adresse e-mail.",
  'app.lable.confirmZipcode': "Vouliez-vous dire que l’adresse est:",
  'app.tooltip.adl':"ADL - Les activités de la vie quotidienne (AVQ) comprennent le bain, l'habillage, les soins d'hygiène personnelle, l'utilisation des toilettes, les transferts, l'aide à la continence et l'assistance pour manger ou s'alimenter.",
  'app.tooltip.adlNote': "ADL (Activités de la vie quotidienne)",
  'app.tooltip.iadlNote':"IADL (Activités instrumentales de la vie quotidienne)",
  'app.tooltip.iadl': "IADL - Les activités instrumentales de la vie quotidienne (AIVQ) comprennent la compagnie, la préparation des repas, les rappels de prise de médicaments, les courses, les démarches et une aide légère aux tâches ménagères.",
  'app.minimalsHourNote': 'Please note the service hours you selected are less than the agency’s minimum hours, and higher hourly rates may apply. Please confirm your service hours selection.',
  'app.scollNote': 'Faites défiler vers le bas pour plus de choix.',
  'app.settings.powered-by': 'Propulsé par HCQ',
  'app.settings.validate-required': 'Ce champ ne doit pas être laissé vide.',
  'app.settings.validate-required-DOB': 'Veuillez indiquer la date de naissance ou l’âge.',
  'app.settings.validate-required-Petcare': 'Veuillez remplir l’un d’entre eux.',
  'app.settings.validate-required-zipcode': 'ZipCode is requises',
  'app.settings.validate-email': 'Entrez une adresse e-mail valide.',
  'app.settings.validate-phone': 'Le numéro de téléphone n’est pas valide.',
  'app.settings.validate-datetime':
    'L’heure n’est pas valide. Format MM/DD/YYYY HH:MM AM/PM (fuseau horaire ET, CT, PT, etc.)',
  'app.settings.validate-time': 'L’heure n’est pas valide. Format HH:MM AM/PM',
  'app.settings.validate-date': 'La date n’est pas valide. Format MM/DD/YYYY',
  'app.settings.validate-date-format': 'Format MM/DD/YYYY',
  'app.settings.validate-date-format_CA': 'Format YYYY/MM/DD',
  'app.settings.validate-datetime.feature': 'La date doit être dans le futur.',
  'app.settings.validate-datetime.past': 'La date doit être dans le passé.',
  'app.settings.validate-date.placeholder': 'MM/DD/YYYY',
  'app.settings.validate-time.placeholder': 'HH:MM AM/PM',
  'app.settings.validate-time.placeholder_commonapp': 'HH:MM AM/PM TZ',
  'app.settings.validate-house-number': 'Veuillez inclure le numéro de rue (ex. : 22 Main St).',
  'app.settings.validate-timezone.placeholder': 'TZ',
  'app.settings.validate-incorrect': 'Ce champ est incorrect',
  'app.settings.validate-confirm': 'Veuillez confirmer vos informations',
  'app.settings.optional.explanation': 'Explication',
  'app.settings.reassessment': 'Devis de réévaluation',
  'app.settings.reassessment.old-quote': 'Le devis saisi',
  'app.settings.reassessment.existing-quote': 'Code de devis existant?',
  'app.settings.reassessment.submit': 'Envoyer',
  'app.settings.reassessment.quote-code': 'Code de devis: ',
  'app.settings.reassessment.message-not-newest':
    'n’est pas la version la plus récente, veuillez confirmer le devis que vous souhaitez réévaluer.',
  'app.settings.select.placeholder': 'Sélectionnez-en un',
  'app.settings.select.placeholder.street': 'Rue',
  'app.settings.select.placeholder.apt': 'Apt/Suite',
  'app.settings.select.placeholder.city': 'Ville',
  'app.settings.select.placeholder.state': 'État',
  'app.settings.select.placeholder.zip': 'Code postal',
  'app.settings.other': 'Autres/Notes/Détails d’ajout (Veuillez utiliser cette section pour toute note/information supplémentaire)',
  'app.settings.uncertain': 'Incertain',
  'app.settings.more-information': 'Plus d’informations',
  'app.settings.description': 'Description',
  'app.settings.callName': 'Nom',
  'app.settings.callPhone': 'Numéro de téléphone',
  'app.settings.validate-section': 'Veuillez remplir toutes les questions requises.',
  'app.settings.date.placeholder': 'MM/DD/YYYY',
  'app.settings.date.placeholderCA': 'YYYY/MM/DD',
  'app.settings.datetime.placeholder': 'MM/DD/YYYY HH:MM AM/PM (fuseau horaire ET, CT, PT, etc.)',
  'app.settings.datetime.placeholderCA': 'YYYY/MM/DD HH:MM AM/PM (fuseau horaire ET, CT, PT, etc.)',
  'app.settings.optional': '(facultatif)',
  'app.label.personCare':'Les services de soins personnels ',
  'app.label.personCare1':'comprennent tous les services d’accompagnement/de garde d’enfants',
  'app.label.personCare2':'et les options affichées (sélectionnez toutes les options applicables) :',
  'app.label.companion':'Les services de compagnon/gardien ',
  'app.label.companion1': ' incluent les options indiquées ci-dessous (sélectionnez toutes les options applicables).`',
  'app.label.companion2': `Les services d'aide aux activités de la vie quotidienne (AVD) ne sont pas inclus dans le service de garde à domicile :`,
  'page.term.accept': 'Accepter',
  'page.term.decline': 'Déclin',
  'page.term.notShowAgain': 'Ne plus afficher',
  'page.term.reviewAgain.button': 'Consulter les conditions générales',
  'page.term.reviewAgain.title': 'Les termes et conditions n’ont pas été acceptés',
  'page.review.title': "Veuillez vérifier l'exactitude du devis.",
  'page.review.title-estimate': 'Confirmation sur le devis',
  'page.review.title-estimate-commonapp': 'Confirmation de votre devis',
  'page.review.button.secondary': 'Imprimer le devis secondaire',
  'page.review.button.print-price': 'Soumettez votre devis',
  'page.review.button.print-price.quote-id': 'ID du devis',
  'page.review.button.create-new-quote': 'Créer un nouveau devis',
  'page.review.note': 'Si vous avez besoin de modifier/modifier/corriger une réponse, veuillez cliquer sur la case que vous souhaitez mettre à jour.',
  'page.quota-exceeded.title': 'Quota dépassé',
  'page.quota-exceeded.description':
    'Le quota de devis a été dépassé. Veuillez prolonger votre plan.',
  'page.quota-exceeded.action': 'Renouvelez votre plan',
  'page.zipcode-error.description': "Actuellement, le service n’est pas disponible dans votre région. Veuillez revenir et réessayer plus tard.",
  'page.zipcode-error.description2': "Veuillez revenir et réessayer plus tard.",
  'page.quota-expired.title': 'Plan expiré',
  'page.quota-expired.description': 'Le plan a expiré. Veuillez renouveler votre plan.',
  'page.quota-expired.action': 'Renouvelez votre plan',
  'page.quota-invalid.title': 'Citation non valide',
  'page.quota-invalid.description':
    'The provided Quote ID was found in our system but is not valid for use. Please try again with another Quote ID.',
  'page.quota-invalid.action': 'Contact HomeCareQuote',
  'page.quota-invalid.action_Myhomecare': 'Contact MyHomeCareQuote',
  'page.400.button.back': 'Précédent',
  'page.alert.expiration': 'This is Demo version. Expiration Date:',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
};
